import React from 'react'

import styles from './ActivityList.module.scss'

const ActivityList = ({ children }) => <ul className={styles.activityList}>{children}</ul>

export default ActivityList
